module.exports = __webpack_public_path__ + "img/header-weddingRingsCrown.89bcbe0.jpg";